import React from 'react';

import Intro from './Intro';
import Outro from './Outro';

const SideBar = () => (
	<section id="sidebar">
		<Intro />
		<Outro />
	</section>
);

export default SideBar;
